import { observer } from 'mobx-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useStore } from '@/stores';

export const ProtectedRoute = observer(function ProtectedRoute() {
  const { authStore } = useStore();
  const location = useLocation();

  if (!authStore.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
});
